import * as h2Api from '../../h2Api'
import * as profileActions from '../../actions/early/occupationProfile'
import * as earlyListingActions from '../../actions/early/earlyListing'

const initialState = {
  selectedProfile: {},
  profileCache: {},
  interests: {},
  workValues: {},
  knowledge: {}
}
const occupationProfile = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.PROFILE_SELECT_LOADED:
      console.log(action.selectedProfile)

      return {
        ...state,
        selectedProfile: action.selectedProfile
      }

    case profileActions.PROFILE_LOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          selectedProfile: p.onetSoc,
          profileCache: {
            ...state.profileCache,
            [p.onetSoc]: p
          }
        }
      }

      return state

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profileCache: (action.restCall.result.occupationProfiles || []).reduce(
            function (map, obj) {
              map[obj.onetSoc] = obj

              return map
            },
            {}
          ),
          interests: action.restCall.result.onetElements.interests,
          knowledge: action.restCall.result.onetElements.knowledge,
          workValues: action.restCall.result.onetElements.workValues
        }
      }

      return state

    case profileActions.CACHE_INITIAL:
      return {
        profileCache: action.value
      }

    default:
      return state
  }
}

export default occupationProfile
